"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLBBox = void 0;
const react_1 = __importStar(require("react"));
const image_1 = __importDefault(require("next/image"));
const router_1 = require("next/router");
const monera_app_core_1 = require("@amzn/monera-app-core");
const requestInvite_1 = require("@amzn/monera-app-core/lib/services/actions/requestInvite");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const page_wrapper_1 = require("../page-wrapper");
const static_component_1 = require("../static-component");
const themed_text_1 = require("../themed-text");
const styles_1 = require("../themed-text/styles");
const styles_2 = require("./styles");
const PLBBox = (props) => {
    var _a;
    const { customerAuthenticated, customerRegistered = false, titleIcon, title, description, statusTitleIcon, statusTitle, statusDescription, subcomponents = [], statusSubcomponents = [], surveyRedirectURL = '', ctaMessage, belowCTAMessage = '', belowCTAAnchorMessage = '', programId = '' } = props;
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    const publicRuntimeConfig = (0, monera_app_core_1.withPublicRuntimeConfig)();
    const [shoppingPortalRegistryState] = (0, monera_app_core_1.useShoppingPortalStore)();
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    const [showStatus, setShowStatus] = (0, react_1.useState)(customerRegistered);
    const [boxTitleIcon, setBoxTitleIcon] = (0, react_1.useState)(customerRegistered ? statusTitleIcon : titleIcon);
    const [boxTitle, setBoxTitle] = (0, react_1.useState)(customerRegistered ? statusTitle : title);
    const [boxDescription, setBoxDescription] = (0, react_1.useState)(customerRegistered ? statusDescription : description);
    const [disableCTA, setDisableCTA] = (0, react_1.useState)(false);
    const router = (0, router_1.useRouter)();
    const getImpressionMetricAttributes = {
        'data-csa-c-type': 'widget',
        'data-csa-c-content-id': 'inviteList',
        'data-csa-c-slot-id': 'inviteList_feature_div',
        'data-csa-c-asin': configStoreState.asin
    };
    const tenant = (_a = configStoreState.tenant) !== null && _a !== void 0 ? _a : window.moneraTenant;
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        setDisableCTA(true);
        const { asin, countryCode, requestId, csrfToken } = configStoreState;
        const { marketplaceId, sessionId, ubid, customerId } = shoppingPortalRegistryState;
        if (!customerAuthenticated) {
            const context = {
                amazonUrl: publicRuntimeConfig.amazonUrl,
                returnUrl: document.location.href,
                countryCode
            };
            const signInUrl = (0, monera_app_core_1.buildSignInUrl)(context);
            router.push(new URL(signInUrl));
        }
        if ((0, monera_app_core_1.isClientSide)()) {
            if (surveyRedirectURL) {
                (0, metric_helper_1.emitCountMetricV2)('PLBBox', 'RedirectToSurvey', 1, tenant);
                window.location.href = surveyRedirectURL;
            }
            else {
                const response = yield (0, requestInvite_1.requestPrelaunchInvite)({
                    requestId,
                    asin,
                    tenant,
                    marketplaceId,
                    sessionId,
                    ubid,
                    csrfToken,
                    customerId,
                    deviceType,
                    programId
                });
                if (response) {
                    setShowStatus(true);
                    setBoxTitleIcon(statusTitleIcon);
                    setBoxTitle(statusTitle);
                    setBoxDescription(statusDescription);
                }
            }
        }
    });
    return (react_1.default.createElement(styles_2.PLBBoxContainerWrapper, null,
        react_1.default.createElement("div", { "data-cy": 'plb-box-inner-container' },
            react_1.default.createElement(styles_2.PLBBoxTitleContainer, { "data-cy": 'plb-box-title' },
                boxTitleIcon && react_1.default.createElement(image_1.default, { src: boxTitleIcon, alt: 'Placeholder' }),
                react_1.default.createElement(styles_1.ThemedH3, null, boxTitle)),
            react_1.default.createElement(styles_2.PLBBoxDescriptionContainer, null,
                react_1.default.createElement(styles_1.ThemedParagraph, { "data-cy": 'plb-box-description' }, boxDescription)),
            !showStatus
                ? subcomponents.map((subcomponent, index) => {
                    const { id, state } = subcomponent;
                    return (react_1.default.createElement("div", { key: id },
                        react_1.default.createElement(static_component_1.StaticComponent, { key: `${id}-${index}`, id: id, state: state })));
                })
                : null,
            showStatus
                ? statusSubcomponents.map((subcomponent, index) => {
                    const { id, state } = subcomponent;
                    return (react_1.default.createElement("div", { key: id },
                        react_1.default.createElement(static_component_1.StaticComponent, { key: `${id}-${index}`, id: id, state: state })));
                })
                : null,
            showStatus ? null : (react_1.default.createElement(styles_2.PLBBuyButtonContainer, { "data-cy": 'plb-box-buy-button-container' },
                react_1.default.createElement(styles_2.PLBFullWidthButton, Object.assign({ "data-cy": 'plb-box-buy-button', "aria-label": ctaMessage }, getImpressionMetricAttributes, { buttonType: "primary", disabled: disableCTA, onClick: handleClick }), ctaMessage),
                react_1.default.createElement(styles_2.BelowCTAMessageContainer, null, customerAuthenticated ? (react_1.default.createElement(BelowCTAMessage, { "data-cy": 'plb-box-below-cta', belowCTAMessage: belowCTAMessage })) : (react_1.default.createElement(CreateAccountMessage, { "data-cy": 'plb-box-create-account', belowCTAMessage: belowCTAMessage, belowCTAAnchorMessage: belowCTAAnchorMessage, countryCode: configStoreState.countryCode }))))))));
};
exports.PLBBox = PLBBox;
const BelowCTAMessage = (props) => {
    const { belowCTAMessage } = props;
    if (!belowCTAMessage) {
        return null;
    }
    return (react_1.default.createElement("div", { "data-cy": 'plb-below-cta-message' },
        react_1.default.createElement(styles_1.ThemedSpan, null, belowCTAMessage)));
};
const CreateAccountMessage = (props) => {
    const { belowCTAMessage, belowCTAAnchorMessage, countryCode } = props;
    const router = (0, router_1.useRouter)();
    const redirectToCreateAccount = () => {
        const runtimeConfig = (0, monera_app_core_1.withPublicRuntimeConfig)();
        const context = {
            amazonUrl: runtimeConfig.amazonUrl,
            returnUrl: document.location.href,
            countryCode
        };
        const registrationUrl = (0, monera_app_core_1.buildRegistrationUrl)(context);
        router.push(new URL(registrationUrl));
    };
    return (react_1.default.createElement("div", { "data-cy": 'plb-account-creation-message' },
        react_1.default.createElement(styles_1.ThemedParagraph, null,
            belowCTAMessage,
            ' ',
            react_1.default.createElement(styles_2.CreateAccountAnchorWrapper, { onClick: redirectToCreateAccount },
                react_1.default.createElement(themed_text_1.ThemedAnchor, { className: "plbCreateAccount", "aria-label": "Create new account" }, belowCTAAnchorMessage)))));
};
